import React from 'react';
import { isPresentedList } from 'utils/collection';
import { LessonCompletedDto } from '@peartherapeutics/hylia-api-client';
import CompletedLessons from '../CompletedLessons';
import { BlockMiddleEmpty } from '../../Widgets/Blocks';

const CompletedLessonsList = ({
  completedLessons,
}: {
  completedLessons: LessonCompletedDto[];
}) =>
  isPresentedList(completedLessons) ? (
    <CompletedLessons completedLessons={completedLessons} />
  ) : (
    <BlockMiddleEmpty
      content="Lesson completion data and quiz results will appear here.
        Patients will earn a reward when they complete 4 lessons per week."
    />
  );

export default CompletedLessonsList;
